import { render, staticRenderFns } from "./nuevaReclamacion.vue?vue&type=template&id=26b41f0c&"
import script from "./nuevaReclamacion.vue?vue&type=script&lang=js&"
export * from "./nuevaReclamacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports